var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toJS } from '@shared/utils/immutable';
// selectors
import { selectLoading, selectArticleError } from '@store/article/selectors';
// actions
import { searchArticle, scanArticle, resetArticleError, } from '@store/article/actions';
// components
import SessionContainer from 'containers/SessionContainer';
import Page from 'pages/Scan';
var Scan = /** @class */ (function (_super) {
    __extends(Scan, _super);
    function Scan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Scan.prototype.render = function () {
        var _this = this;
        return (_jsx(SessionContainer, { children: function (sessionProps) { return (_jsx(Page, __assign({}, sessionProps, { searchArticle: _this.props.searchArticle, scanArticle: _this.props.scanArticle, loading: _this.props.loading, error: _this.props.error, resetArticleError: _this.props.resetArticleError }), void 0)); } }, void 0));
    };
    return Scan;
}(Component));
var select = function () { return function (props) { return ({
    error: selectArticleError(props),
    loading: selectLoading(props),
}); }; };
export default withRouter(connect(select, {
    searchArticle: searchArticle,
    scanArticle: scanArticle,
    resetArticleError: resetArticleError,
})(toJS(Scan)));
